module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kT1YQ"))).then(() => parcelRequire('1iHdE'));